import { render } from "./InstagramFeed.vue?vue&type=template&id=da364f88&scoped=true"
import script from "./InstagramFeed.vue?vue&type=script&lang=js"
export * from "./InstagramFeed.vue?vue&type=script&lang=js"

import "./InstagramFeed.vue?vue&type=style&index=0&id=da364f88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-da364f88"

export default script